<template>
  <thead>
    <tr>
      <th
        :class="nameClass"
        @click="setSortBy('name')"
      >
        {{ nameTitle }}
      </th>
      <th
        :class="countClass"
        style="width: 25%;"
        @click="setSortBy('count')"
      >
        Count
      </th>
    </tr>
  </thead>
</template>

<script>

export default {
  name: 'StatsBlockTitle',
  props: {
    nameTitle: {
      type: String,
      required: true,
    },
    initSortBy: {
      type: String,
      required: true,
    },
    initSortOrder: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      sortBy: this.initSortBy,
      sortOrder: this.initSortOrder,
    }
  },
  computed: {
    nameClass: function () {
      let c = ''
      if (this.sortBy === 'name') {
        c = this.sortOrder === 'desc' ? 'sort descending' : 'sort ascending'
      }
      return c
    },
    countClass: function () {
      let c = ''
      if (this.sortBy === 'count') {
        c = this.sortOrder === 'desc' ? 'sort descending' : 'sort ascending'
      }
      return c
    },
  },
  methods: {
    setSortBy: function (sortBy) {
      if (sortBy === this.sortBy) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = sortBy
        this.sortOrder = sortBy === 'name' ? 'asc' : 'desc'
      }
      this.$emit('sortChange', { by: this.sortBy, order: this.sortOrder })
    },
  },
}

</script>
